export default __webpack_public_path__ + "static/banner-mobiel-a2c52fe40a29221efe75afa2605e6650.jpg";